document.addEventListener("DOMContentLoaded", function () {
    const contentPaddingTop = 0;

    const parallaxElement = document.querySelector('.parallax');

    if (parallaxElement) {
        const parentContainer = document.querySelector('.parallax-container');

        if (parentContainer) {
            function applyParallaxEffect() {
                if (window.innerWidth <= 1120) {
                    parallaxElement.style.transform = 'translateY(0)';
                    return;
                }

                const containerRect = parentContainer.getBoundingClientRect();
                const parallaxHeight = parallaxElement.offsetHeight;
                const containerHeight = parentContainer.offsetHeight;

                const parentPaddingTop = parseFloat(getComputedStyle(parentContainer).paddingTop) || 0;

                const maxScrollAmount = Math.max(0, containerHeight - parallaxHeight - contentPaddingTop - parentPaddingTop);

                if (containerRect.top <= window.innerHeight && containerRect.bottom >= 0) {
                    let scrollAmount = window.scrollY - parentContainer.offsetTop;

                    scrollAmount = Math.max(0, Math.min(scrollAmount, maxScrollAmount));

                    parallaxElement.style.transform = `translateY(${scrollAmount}px)`;
                }
            }

            applyParallaxEffect();

            window.addEventListener('scroll', applyParallaxEffect);
            window.addEventListener('resize', applyParallaxEffect);
        }
    }
})